// extracted by mini-css-extract-plugin
export default {"cardsItems":"Pedidos_cardsItems__idDZz","cardOrders":"Pedidos_cardOrders__6Mbc4"};